import React from 'react'
import { EditIcon, Tag } from '../../lib/components'
import { WebinarStatus } from '../webinars-form/constants'
import { getFormattedDate } from '../../lib/utils/helpers'

export type WebinarCardProps = {
  id: number
  thumbnailUrl: string
  title: string
  description: string
  youtubeVideoId: string
  status: WebinarStatus
  publishedAt: string
  createdAt: string
  updatedAt: string
  handleEditClick: (id: number) => void
}

export function WebinarCard({
  id,
  thumbnailUrl,
  title,
  description,
  youtubeVideoId,
  status,
  publishedAt,
  createdAt,
  updatedAt,
  handleEditClick,
}: WebinarCardProps) {
  const formattedDate = (date: string) => getFormattedDate(new Date(date), 'D MMM YYYY [at] h:mm A')
  const textEllipsis = (text: string, maxLength: number) =>
    text.length > maxLength ? text.slice(0, maxLength) + '...' : text

  return (
    <tr key={id}>
      <td>
        <img
          src={thumbnailUrl}
          alt={title}
          className='w-100 h-100 object-fit-cover'
          loading='lazy'
          style={{ borderRadius: '8px', maxWidth: '120px' }}
        />
      </td>
      <td>
        <Tag text={status} variant={status === 'DRAFT' ? 'white-bg' : 'gold-bg'} />
      </td>
      <td>{textEllipsis(title, 100)}</td>
      <td>{textEllipsis(description, 100)}</td>
      <td>{youtubeVideoId}</td>
      <td>{formattedDate(publishedAt)}</td>
      <td>{formattedDate(createdAt)}</td>
      <td>{formattedDate(updatedAt)}</td>
      <td>
        <EditIcon
          classes={['align-center', 'pointer']}
          height='24'
          width='24'
          onClick={() => handleEditClick(id)}
          dataTestId='webinar-list-card-edit-icon'
        />
      </td>
    </tr>
  )
}
